<script>
import Stars from "@/components/_Shared/Professionals/Stars";

export default {
  props: {
    feedback: {
      type: Object,
      required: true
    }
  },
  components: {
    Stars
  }
};
</script>

<template>
  <section @click="$emit('click')" class="feedback">
    <stars :rating="feedback.rating" />
    <small>"{{feedback.description}}"</small>
  </section>
</template>

<style scoped>
.feedback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-bottom: 15px;
}

.feedback small {
  color: #333;
}

small {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  font-style: italic;
}

@media (min-width: 920px) {
  .feedback {
    padding: 0 50px 15px 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Professionals/Feedbacks/Feedback.vue